import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import moment from 'moment';

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(moment);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
